import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { WorkflowBuilderPage } from "@/features/workflow-builder";

export const Route = createFileRoute("/workflow-builder/")({
  component: () => (
    <PermissionGuard module="workflow_builder">
      <WorkflowBuilderPage />
    </PermissionGuard>
  ),
});
